import axios from "axios";

function queryString(params = {}) {
    const query = new URLSearchParams();
    Object.keys(params).forEach((key) => {
        const value = params[key];
        if (value !== undefined && value !== null && value !== "") {
            query.append(key, value);
        }
    });
    const text = query.toString();
    return text ? "?" + text : "";
}

export function getThirdPartyInvokeLogPage(params) {
    return axios.get("/api/bms/third-party-invoke-log" + queryString(params)).then((res) => res.data);
}
